var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, html, Prop, Watch } from '@sick-davinci/ce-decorators';
import { style } from './BarChartBullet.style';
import * as QuickChart from '@meistercharts/meistercharts';
import { ValueRangeScale } from '../../_utils/ValueRange.js';
import { computeThresholds } from '../../_utils/Thresholds.js';
import { ThemeService } from '../../_utils/ThemeService.js';
import { resolveCssColor, toCssColors, toCssColorValue } from '../../_utils/ColorTools.js';
import { CssTools } from '../../_utils/CssTools.js';
import { ValueRangeTools } from '../../_utils/ValueRangeTools.js';
import { createBalloonTooltipStyle } from '../../_utils/TooltipTools.js';
import { createValuesGridStyle } from '../../_utils/GridTools.js';
import { LegendGrid } from '../../legend/LegendGrid.js';
import { sanitizeJustifyContent } from '../../_utils/JustifyContent.js';
import { AbstractChart } from '../../_utils/AbstractChart.js';
import { safeNumber } from '../../_utils/SanitizeTools.js';
/**
 * A bullet chart.
 * This chart supports logarithmic value ranges.
 *
 * @example
 * ```html
 * <davinci-element-container heading="Bullet Chart" style="width: 400px; height: 300px">
 *   <davinci-bar-chart-bullet values='[
 *    { "current": -2, "barStart": -7, "barEnd": 12 },
 *    { "current": -6, "barStart": 5, "barEnd": 17 },
 *    { "current": 12, "barStart": 8, "barEnd": 25 }]' bar-labels='["A", "B", "C"]' bar-colors="[0, 1, 2]" legend-labels='["one", "two", "three"]'></davinci-bar-chart-bullet>
 * </davinci-element-container>
 * ```
 */

export let BarChartBullet = (_dec = Component({
  tag: 'davinci-bar-chart-bullet',
  style,
  dependencies: [LegendGrid]
}), _dec2 = Watch('palette'), _dec3 = Reflect.metadata("design:paramtypes", []), _dec4 = Prop({
  reflectAsAttribute: false,
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Watch('horizontal'), _dec7 = Reflect.metadata("design:paramtypes", []), _dec8 = Prop({
  reflectAsAttribute: false
}), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Watch('values'), _dec11 = Reflect.metadata("design:paramtypes", []), _dec12 = Prop({
  reflectAsAttribute: false
}), _dec13 = Reflect.metadata("design:type", Object), _dec14 = Watch('thresholds'), _dec15 = Reflect.metadata("design:paramtypes", []), _dec16 = Prop({
  reflectAsAttribute: false
}), _dec17 = Reflect.metadata("design:type", Object), _dec18 = Prop({
  reflectAsAttribute: false
}), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Watch('barColors'), _dec21 = Reflect.metadata("design:paramtypes", []), _dec22 = Prop({
  reflectAsAttribute: false
}), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Prop({
  type: String
}), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Prop({
  type: Boolean
}), _dec27 = Reflect.metadata("design:type", Boolean), _dec28 = Watch('noTooltip'), _dec29 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class BarChartBullet extends AbstractChart {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "horizontal", _descriptor, this);

    _initializerDefineProperty(this, "values", _descriptor2, this);

    _initializerDefineProperty(this, "thresholds", _descriptor3, this);

    _initializerDefineProperty(this, "barColors", _descriptor4, this);

    _initializerDefineProperty(this, "noTooltip", _descriptor5, this);
  }

  /**
   * The api reference that is used to delegate the calls
   */

  /**
   * Called if palette property changes
   */
  paletteWatcher() {
    this._update();
  }
  /**
   * Whether the bars are horizontal (true) or vertical (false)
   *
   * @default false
   */


  horizontalWatcher() {
    this._update();
  }
  /**
   * The values of the bars.
   */


  valuesWatcher() {
    this._update();
  }
  /**
   * The thresholds to be shown.
   */


  thresholdsWatcher() {
    this._update();
  }
  /**
   * The label for each bar.
   *
   * @default []
   */


  get barLabels() {
    return this._getCategoryLabels();
  }

  set barLabels(value) {
    this._setCategoryLabels(value);

    this._update();
  }
  /**
   * The colors to be used for the bars.
   * The first element denotes the color for the first bar,
   * the second element denotes the color for the second bar and so on.
   *
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)').
   *
   * If there are more bars than colors the array will be traversed from the beginning.
   *
   * Pass an empty array to use all colors of the current palette.
   *
   * @default [0] - use the first color of the current color-palette for all bars.
   */


  barColorsWatcher() {
    this._update();
  }

  _resolveBarColors() {
    return this.barColors === undefined || this.barColors.length === 0 ? toCssColors(this.palette) : this.barColors;
  }
  /**
   * The icons to be used for the bars (one icon per bar).
   *
   * @default []
   */


  get icons() {
    return this._getCategoryIcons();
  }

  set icons(value) {
    this._setCategoryIcons(value);

    this._update();
  }
  /**
   * Customize the lay out the labels and icons of the category axis.
   *
   * @default SpaceGreedily
   */


  get justifyCategoryAxis() {
    return this._justifyCategoryAxis;
  }

  set justifyCategoryAxis(value) {
    this._justifyCategoryAxis = sanitizeJustifyContent(value, 'SpaceGreedily');

    this._update();
  }
  /**
   * Whether tooltips are disabled.
   *
   * @default false (tooltips are enabled by default)
   */


  noTooltipWatcher() {
    this._update();
  }

  _update() {
    var _this$shadowRoot;

    if (this._api === undefined) {
      return;
    }

    const host = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.host;

    if (!host) {
      return;
    }

    const hostFontFamily = this._getHostFontFamily();

    const computedValueRange = this._computeValueRange();

    this._api.setConfiguration({
      categories: this._computeCategories(),
      barColors: this._computeBarColors(),
      barSize: CssTools.REM2PIXEL(1.5),
      minGapBetweenCategories: this.horizontal ? CssTools.REM2PIXEL(1.0) : CssTools.REM2PIXEL(0.5),
      maxGapBetweenCategories: CssTools.REM2PIXEL(20.0),
      currentValueIndicatorSize: CssTools.REM2PIXEL(2.0),
      currentValueIndicatorColor: resolveCssColor('var(--davinci-color-text-on-background-input)'),
      currentValueIndicatorOutlineColor: resolveCssColor('var(--davinci-color-background-input)'),
      horizontal: this.horizontal,
      valueRange: computedValueRange,
      activeCategoryBackgroundColor: resolveCssColor('var(--davinci-color-background-elements-overlay-2)'),
      showTooltip: !this.noTooltip,
      tooltipStyle: this._computeTooltipStyle(hostFontFamily),
      thresholds: computeThresholds(this.thresholds, !this.horizontal, this._getHostFontFamily(), this.shorthandLabels, this.decimalPlaces),
      valuesGridStyle: createValuesGridStyle('value', computedValueRange),
      categoriesGridStyle: {
        visible: false
      },
      valueAxisStyle: this._computeValueAxisStyle(this.horizontal, hostFontFamily),
      categoryAxisStyle: this._computeCategoryAxisStyle(this.horizontal, hostFontFamily),
      contentViewportMargin: {
        right: this.horizontal ? CssTools.REM2PIXEL(1.5) : 0
      },
      overflowIndicatorStyle: {
        arrowHeadLength: 0,
        arrowHeadWidth: 0
      }
    });
  }

  _init() {
    var _this$shadowRoot2;

    if (!this._api) {
      return;
    }

    const holder = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById('holder');

    if (!holder) {
      return;
    }

    holder.appendChild(this._api.holder); // initial update

    this._update();
  }
  /**
   * @override
   */


  componentFirstRender() {
    super.componentFirstRender();

    this._init();
  }
  /**
   * @override
   */


  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(this._themeListener);
    this._api = QuickChart.createBulletChart(); // this could be a reattach without a following call for componentFirstRender -> reestablish QuickChart API

    this._init();
  }
  /**
   * @override
   */


  componentDisconnected() {
    super.componentDisconnected();
    ThemeService.GET_INSTANCE().removeListener(this._themeListener); // We have been detached from the DOM -> clean up

    if (this._api) {
      var _this$shadowRoot3, _this$shadowRoot3$get;

      (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : (_this$shadowRoot3$get = _this$shadowRoot3.getElementById('holder')) === null || _this$shadowRoot3$get === void 0 ? void 0 : _this$shadowRoot3$get.removeChild(this._api.holder);

      this._api.dispose();
    }

    delete this._api;
  }
  /**
   * @override
   */


  render() {
    var _this$shadowRoot4;

    // recycle holder if needed: holds the actual chart as a child
    let holder = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.getElementById('holder');

    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('id', 'holder');
    }

    if (this.legendLabels.length > 0) {
      return html`
      <davinci-legend
        placement="N"
        small-font
        compact
        symbols='["box"]'
        symbol-size="${CssTools.REM2PIXEL(.7)}"
        .labels=${this.legendLabels}
        .palette=${this.palette}
        .colors=${this._resolveBarColors()}>
        ${holder}
      </davinci-legend>
      `;
    } else {
      return html`${holder}`;
    }
  }

  _computeCategories() {
    const maxLength = Math.max(this.values.length, this.barLabels.length, this.icons.length);
    const categories = Array.from(Array(maxLength), () => ({
      current: Number.NaN,
      barStart: Number.NaN,
      barEnd: Number.NaN
    }));
    this.values.forEach((value, index) => {
      const category = categories[index];
      category.current = safeNumber(value.current);
      category.barStart = safeNumber(value.barStart);
      category.barEnd = safeNumber(value.barEnd);

      if (category.barStart > category.barEnd) {
        // eslint-disable-next-line
        console.warn(`barStart (${category.barStart}) is greater than barEnd (${category.barEnd}); the ${index + 1}. bar won't be visible`);
      }
    });
    this.barLabels.forEach((label, index) => categories[index].label = label);
    this.icons.forEach((icon, index) => categories[index].image = icon);
    return categories;
  }

  _computeBarColors() {
    return this._resolveBarColors().map(color => toCssColorValue(color, this.palette));
  }

  *_allValues() {
    for (const value of this.values) {
      yield value.barStart;
      yield value.barEnd;
      yield value.current;
    }
  }

  _computeValueRange() {
    const computedValueRange = ValueRangeTools.COMPUTE_VALUE_RANGE(this._allValues(), this.valueRange);
    return {
      start: computedValueRange.start,
      end: computedValueRange.end,
      scale: computedValueRange.scale === ValueRangeScale.linear ? 'Linear' : 'Log10'
    };
  }

  _computeTooltipStyle(hostFontFamily) {
    const style = createBalloonTooltipStyle(hostFontFamily, this.shorthandLabels, this.decimalPlaces); // adjust the symbol-size so we have lines instead of squares

    const symbolSize = CssTools.REM2PIXEL(0.75);
    style.symbolSizes = [this.horizontal ? {
      width: 2,
      height: symbolSize
    } : {
      width: symbolSize,
      height: 2
    }, {
      width: symbolSize,
      height: symbolSize
    }];
    return style;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "horizontal", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "horizontalWatcher", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "horizontalWatcher"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "values", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "valuesWatcher", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "valuesWatcher"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "thresholds", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "thresholdsWatcher", [_dec14, _dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "thresholdsWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "barLabels", [_dec16, _dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "barLabels"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "barColors", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "barColorsWatcher", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "barColorsWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "justifyCategoryAxis", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "justifyCategoryAxis"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "noTooltip", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "noTooltipWatcher", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "noTooltipWatcher"), _class2.prototype)), _class2)) || _class);
